import { CustomButton } from 'shared_ui_components';
import { TooltipCustom } from 'utils';
import { Button } from '@material-ui/core';
import SubmitPublicRoleplayLogic from './SubmitPublicRoleplay.logic';

const SubmitRealPlay = () => {
  const { isLoadingVideoTemp, allHaveVideos, label, onSubmit, handleSubmit, isDisabled, status } =
    SubmitPublicRoleplayLogic();

  return allHaveVideos ? (
    <CustomButton onClick={handleSubmit} className="primaryBtn" style={{ width: '100%' }}>
      Submit
    </CustomButton>
  ) : status === 'INCOMPLETE' ? (
    <TooltipCustom
      title={"Your video doesn't have content or interaction, please interact with the coach"}
      arrow
      placement="top"
    >
      <span>
        <Button style={{ width: '100%', pointerEvents: 'visible !important' }} disabled>
          {label}
        </Button>
      </span>
    </TooltipCustom>
  ) : (
    <CustomButton
      onClick={onSubmit}
      className="primaryBtn"
      style={{ width: '100%' }}
      disabled={isDisabled || isLoadingVideoTemp}
    >
      {label}
    </CustomButton>
  );
};

export default SubmitRealPlay;
